import { createFileRoute } from "@tanstack/react-router";
import { AdminListingApprovalPage } from "@/components/AdminListingApproval";

export const Route = createFileRoute("/_authenticated/admin/listings/rejected")({
  head: () => ({
    meta: [
      { title: "Rejected Listings · Landoo Admin" },
      { name: "description", content: "Listings rejected during moderation." },
    ],
  }),
  component: () => <AdminListingApprovalPage status="rejected" />,
});
